// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"c9467cca","261":"6c6bd309","338":"c684e0c2","456":"e7583304","541":"3a4c75e2","544":"7409f0a6","576":"2fa1667f","753":"026c991e","775":"d16c3034","823":"43e2c7fa","980":"6e9739d9"}[chunkId] + ".js";
};